<template>
  <vx-card class="compact-card">
    <div class="header header-title">
      <slot name="header"></slot>
    </div>
    <div>
      <slot></slot>
    </div>
  </vx-card>
</template>

<script>
export default {
  name: "SectionWithDivider",
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

.compact-card {
  ::v-deep .vx-card__body {
    padding: 0 !important;
  }
}

.header {
  display: flex;
  align-items: center;
  align-self: stretch;
  border-bottom: 1px solid $aisea-light-white;
  padding: 0px 30px;
  min-height: 60px;

  .action-area {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .btn-primary {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 24px;
    border-radius: 6px;
    border: 1px solid $aisea-blue;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: rgba(3, 155, 229, 0.05);
    }

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    }

    .text {
      color: $aisea-blue;
      text-align: center;
      font-family: "Hiragino Sans", -apple-system, Roboto, Helvetica, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }
  }
}
</style>
